export const NFT_addr = '0x27a08293C88752B3F9d7EB5521959d211844eBb5'
export const USDG_addr = '0x9dE8e8FD179eeFdc8AFB76f7c38FEf93fcD68A57'
export const config_addr = '0x4f80DDc69084683DEaab5D9250AEa85aFEE4EFA6'
export const market_addr = '0xe54C9C720cBF0147321c08320b2f51490912060a'
export const uSDT_addr = '0xD3D656958aA688BD5C1Bc917bd335B879ACB5A20'
export const StableVault_addr = '0x021FD978080d648f912533c97810E7d41bF28273'
